import { render, staticRenderFns } from "./TipoEnergiaField.vue?vue&type=template&id=09b84458&scoped=true&"
import script from "./TipoEnergiaField.vue?vue&type=script&lang=js&"
export * from "./TipoEnergiaField.vue?vue&type=script&lang=js&"
import style0 from "./TipoEnergiaField.vue?vue&type=style&index=0&id=09b84458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b84458",
  null
  
)

export default component.exports